import { StyleSheet } from 'react-native-unistyles';

export const styles = StyleSheet.create({
  errorContainer: {
    flex: 1,
    paddingHorizontal: 24,
  },
});
